module.exports = __webpack_public_path__ + "img/grass_header.6c157efb.png";